export const dummyRecentSearchHistoy = [
  "Sauces & Spreads",
  "Tea & Coffee",
  "Cold Drinks & Juices",
  "Personal Care",
];
